import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  padding: 25px;
  text-align: center;

  .inner {
    padding: 35px;
    width: 80%;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 15px;
    margin: auto;
    text-align: left;
    max-width: 500px;

    .button-container {
      text-align: center;
      margin-bottom: 1em;

      button:disabled {
        cursor: not-allowed;
        background: var(--grey-2) !important;
      }
    }

    small {
      font-size: 13px;
      text-align: center;
      margin: auto;
      display: block;

      &.error {
        color: red;
      }
    }
  }

  p {
    margin-bottom: 1em;
  }

  h1 {
    margin: 0 0 15px 0;
    text-align: left;
  }

  h2 {
    margin-top: 25px;
  }

  ul {
    margin-top: 25px;

    li {
      margin-bottom: 5px;
    }
  }
`;
